import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { Toaster } from 'sonner';
import { MaintenanceScreen } from '@/components/feedback/MaintenanceScreen';
import { AuthProvider } from '@/features/auth/auth-context';
import { queryClient } from '@/lib/query-client';
import { AppContextProvider } from './app-context';
import { LocationProvider } from './location-context';
import { router } from './router';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppContextProvider>
          <LocationProvider>
            <RouterProvider router={router} />
            <MaintenanceScreen />
          </LocationProvider>
        </AppContextProvider>
      </AuthProvider>
      <Toaster
        position="top-center"
        richColors
        closeButton
        toastOptions={{ className: 'font-sans', style: { fontSize: '15px' } }}
      />
    </QueryClientProvider>
  );
}
